var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account_balance-white-18dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ledger-Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Invoices_Account-Number-Text-Tooltip",
    transform: "translate(-1048.000000, -188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(729.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account_balance-white-18dp",
    transform: "translate(319.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.500000, 0.750000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.5,
    y: 6.75,
    width: 2.25,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.375,
    y: 6.75,
    width: 2.25,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 13.5,
    width: 15,
    height: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.25,
    y: 6.75,
    width: 2.25,
    height: 5.25
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.5 0 0 3.75 0 5.25 15 5.25 15 3.75"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalance);
export default __webpack_public_path__ + "static/media/account_balance.1a6d0cc405d3a2f0a8b5e7116994f5a4.svg";
export { ForwardRef as ReactComponent };